module.exports = __webpack_public_path__ + "54d6cb2f693ceb46c5ae49b090874d1b.svg";


//////////////////
// WEBPACK FOOTER
// ./doc/imgs/features.svg
// module id = 244
// module chunks = 1 2